import React, { useState } from 'react';
import { API_ENDPOINTS } from '../config/api';
import './SecurityPage.css';

const SecurityPage = () => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const updateCode = value => {
    setCode(value.replace(/\D/g, '').slice(0, 6));
    setError('');
    setResult(null);
  };
  const pressKey = key => {
    if (loading) return;
    updateCode(key === 'clear' ? '' : key === 'backspace' ? code.slice(0, -1) : code + key);
  };
  const handleSubmit = async event => {
    event.preventDefault();
    if (loading || code.length !== 6) return;
    setLoading(true);
    setError('');
    setResult(null);
    try {
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/api/security/verify-code`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ code })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Verification failed');
      setResult(data);
      setCode('');
    } catch (error) {
      setError(error.message === 'Failed to fetch' ? 'Network error. Please try again.' : error.message);
    } finally {
      setLoading(false);
    }
  };

  return <main className="security-kiosk" aria-label="School security code verification">
    <form onSubmit={handleSubmit} className="security-kiosk-form">
      <div className="security-code-display">
        <input id="code" aria-label="Security Code" type="text" value={code}
          onChange={event => updateCode(event.target.value)} placeholder="000000" maxLength={6}
          inputMode="none" pattern="[0-9]{6}" autoComplete="off" disabled={loading}/>
        <div className="security-code-feedback" aria-live="polite" aria-atomic="true">
          {error && <p role="alert" className="security-code-error">{error}</p>}
          {result?.success && <div className="security-code-success">
            <p>{result.message}</p>
            <p>{result.student?.name}{result.student?.class ? ` / ${result.student.class}` : ''}</p>
          </div>}
        </div>
      </div>
      <div className="security-code-keypad" role="group" aria-label="Security code number keypad">
        {['1', '2', '3', '4', '5', '6', '7', '8', '9', 'clear', '0', 'backspace'].map(key =>
          <button key={key} type="button"
            className={key === 'clear' || key === 'backspace' ? 'security-key-action' : ''}
            aria-label={key === 'clear' ? 'Clear code' : key === 'backspace' ? 'Backspace' : key}
            title={key === 'clear' ? 'Clear code' : key === 'backspace' ? 'Delete last digit' : undefined}
            disabled={loading || (key === 'clear' || key === 'backspace' ? !code.length : code.length === 6)}
            onClick={() => pressKey(key)}>
            {key === 'clear' ? 'Clear' : key === 'backspace' ? '\u232b' : key}
          </button>)}
        <button type="submit" className="security-verify-key" disabled={loading || code.length !== 6}>
          {loading ? 'Verifying...' : 'Verify Code'}
        </button>
      </div>
    </form>
  </main>;
};

export default SecurityPage;
